module.exports = __webpack_public_path__ + "img/团队协作统计.bde3fdb0.png";